<h2 mat-dialog-title>
  {{ mode === 'create' ? 'Add Staff' : mode === 'edit' ? 'Edit Staff' : 'Update My Staff Profile' }}
</h2>

<mat-dialog-content [formGroup]="form">
  <mat-form-field appearance="fill" class="w-full" *ngIf="!isSelfMode">
    <mat-label>Employee ID</mat-label>
    <input matInput formControlName="employeeId" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Full Name</mat-label>
    <input matInput formControlName="fullName" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full" *ngIf="!isSelfMode">
    <mat-label>Email</mat-label>
    <input matInput type="email" formControlName="email" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Phone Number</mat-label>
    <input matInput formControlName="phoneNumber" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Department</mat-label>
    <input matInput formControlName="department" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Position</mat-label>
    <mat-select formControlName="position">
      <mat-option *ngFor="let p of positions" [value]="p">{{ p }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Employment Type</mat-label>
    <input matInput formControlName="employmentType" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Hire Date</mat-label>
    <input matInput type="date" formControlName="hireDate" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Address</mat-label>
    <textarea matInput rows="2" formControlName="address"></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full" *ngIf="!isSelfMode">
    <mat-label>Attach User Account (optional)</mat-label>
    <mat-select formControlName="userId">
      <mat-option value="">None</mat-option>
      <mat-option *ngFor="let u of users" [value]="u.id">
        {{ u.fullName || u.email }} ({{ u.email }})
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-slide-toggle *ngIf="!isSelfMode" formControlName="isActive">Active</mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="loading">
    {{ mode === 'create' ? 'Create' : 'Save' }}
  </button>
</mat-dialog-actions>
